import { Dangerous } from '@mui/icons-material';
import { Badge, Box } from '@mui/material';

export const FSPErrorIndicator = ({ count }: { count: number }) => {
  return (
    <Box color="var(--error)">
      <Badge badgeContent={count} color="default">
        <Dangerous color="error" />
      </Badge>
    </Box>
  );
};
